import { useMutation } from '@tanstack/react-query';

import { postSupplier } from './suppliers';
import type { CreateSupplierPayload } from './suppliers.types';
import { TypesenseCollection } from '@/api/typesense/types';
import { useUpdateSelectQueryDataOnOptionCreation } from '@/hooks/forms';

export const useCreateSupplier = () => {
  const { injectOptionIntoBaseQuery, invalidateSearchQueries } =
    useUpdateSelectQueryDataOnOptionCreation();

  return useMutation({
    mutationFn: (supplierData: CreateSupplierPayload) => {
      return postSupplier(supplierData);
    },
    onSuccess: (data) => {
      injectOptionIntoBaseQuery(TypesenseCollection.SUPPLIERS_VIEW, {
        id: data.id.toString(),
        value: data.name,
      });

      invalidateSearchQueries(TypesenseCollection.SUPPLIERS_VIEW);
    },
  });
};
